import React from 'react';
import { Dialog, DialogContent, Box } from '@material-ui/core';
import Axios from 'config';
import useAsync from 'components/templates/print-v2/hooks/useAsync';
import toaster from 'toasted-notes';
import 'toasted-notes/src/styles.css';

const StopSync = ({ isOpen, toggleModal, id }) => {
  const { execute, status } = useAsync(stopSync, false);

  function stopSync() {
    return Axios.get(`/backup-progress/stop?progress_id=${id}`).then((response) => {
      if (response.success) {
        toaster.notify('Sync stopped successfully', {
          duration: '4000',
          position: 'bottom',
        });
        toggleModal();
      }
    });
  }

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={toggleModal}
        disableBackdropClick={false}
        disableEscapeKeyDown={true}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        fullWidth='500px'>
        <DialogContent>
          <Box>
            <h6 className='text-center'>Are you sure you want to cancel this sync.</h6>
          </Box>

          <Box className='text-center mt-4 mb-4 d-flex justify-content-center'>
            <button className='btn btn-outline-secondary mr-4' disabled={status === 'pending'} onClick={toggleModal}>
              Cancel
            </button>
            <button className='btn btn-outline-danger' disabled={status === 'pending'} onClick={execute}>
              {status === 'pending' ? 'Stopping Sync...' : 'Stop Sync'}
            </button>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default StopSync;
